<mat-dialog-content>
  <lemon-dialog-header> Selvityspyyntöjen historia </lemon-dialog-header>

  <table class="selvityspyyntohistoria-taulukko">
    <thead>
      <tr>
        <th>Päivä</th>
        @if (naytaKirjausrivi()) {
          <th>Rivi</th>
        }
        <th>Kysymys</th>
        <th>Vastaus</th>
        <th>Vastaaja</th>
      </tr>
    </thead>
    <tbody>
      @for (rivi of rivit(); track $index) {
        <tr>
          <td class="selvityspyyntohistoria-paiva">{{ rivi.paiva }}</td>
          @if (naytaKirjausrivi()) {
            <td>{{ rivi.kirjausrivi }}</td>
          }
          <td>{{ rivi.kysymys }}</td>
          <td class="selvityspyyntohistoria-vastaus">{{ rivi.vastaus }}</td>
          <td>{{ rivi.vastaaja }}</td>
        </tr>
      }
    </tbody>
  </table>
</mat-dialog-content>
<mat-dialog-actions>
  <app-primary-button mat-dialog-close actionId="Sulje (selvityspyyntöjen historia dialog)">Sulje</app-primary-button>
</mat-dialog-actions>
